import React, { useState } from 'react';
import { X, Ban, RotateCcw, UserMinus } from 'lucide-react';
import '../styles/EstadoDialog.css';

const CONFIG = {
  BLOQUEADO: {
    icono: Ban,
    tono: 'peligro',
    titulo: '¿Bloquear este cliente?',
    detalle:
      'El cliente deja de estar disponible para operaciones. No se borra nada: el registro y su historial se conservan.',
    confirmar: 'Bloquear cliente'
  },
  ACTIVO: {
    icono: RotateCcw,
    tono: 'positivo',
    titulo: '¿Reactivar este cliente?',
    detalle: 'El cliente vuelve a quedar disponible para operaciones.',
    confirmar: 'Reactivar cliente'
  },
  INACTIVO: {
    icono: UserMinus,
    tono: 'neutro',
    titulo: '¿Desactivar este cliente?',
    detalle:
      'Se marca como inactivo por falta de operación. No se borra nada y puede reactivarse después.',
    confirmar: 'Desactivar cliente'
  }
};

function EstadoDialog({ cliente, estadoDestino, onConfirmar, onCerrar, enviando }) {
  const [motivo, setMotivo] = useState('');
  const cfg = CONFIG[estadoDestino];
  if (!cfg) return null;
  const Icono = cfg.icono;

  return (
    <div className="estado-overlay" onClick={onCerrar}>
      <div
        className="estado-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="estado-titulo"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="estado-cerrar" onClick={onCerrar} aria-label="Cerrar">
          <X size={17} strokeWidth={1.75} />
        </button>

        <span className={`estado-icono is-${cfg.tono}`}>
          <Icono size={19} strokeWidth={1.75} />
        </span>

        <h2 id="estado-titulo">{cfg.titulo}</h2>
        <p className="estado-cliente">
          {cliente.nombreCompleto} · <span>{cliente.folio}</span>
        </p>
        <p className="estado-detalle">{cfg.detalle}</p>

        <div className="estado-campo">
          <label htmlFor="motivo">
            Motivo <span className="estado-opcional">(opcional)</span>
          </label>
          <textarea
            id="motivo"
            rows={2}
            value={motivo}
            placeholder="Queda registrado en la bitácora del cliente"
            onChange={(e) => setMotivo(e.target.value)}
          />
        </div>

        <div className="estado-acciones">
          <button className="btn btn-secondary" onClick={onCerrar} disabled={enviando}>
            Cancelar
          </button>
          <button
            className={`btn ${cfg.tono === 'peligro' ? 'btn-danger' : 'btn-primary'}`}
            onClick={() => onConfirmar(motivo.trim() || null)}
            disabled={enviando}
          >
            {enviando ? 'Aplicando…' : cfg.confirmar}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EstadoDialog;
